let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("5VWb9")).then(() => parcelRequire('6ygMR'));